module.exports = __webpack_public_path__ + "img/icon-password.33555147.png";